<template>
  <div>
    <Standard v-if="pageType == 'standard'" :id="id" :slug="slug" />
  </div>
</template>

<script>
    import Standard from "./Standard.vue"

    export default {
        props: ["id", "slug", "pageType"],
        components: {Standard}
    };
</script>



// WEBPACK FOOTER //
// src/components/products/src/productPage/Manager.vue